import React, { createContext } from 'react';

export const PROFILE_EDITOR_DRAWER_SKILLS_TYPES = {
  SKILL: 'skill',
  SOFTWARE: 'software',
  CERTIFICATION: 'certification',
};

export type ProfileEditorDrawerSkillsType =
  (typeof PROFILE_EDITOR_DRAWER_SKILLS_TYPES)[keyof typeof PROFILE_EDITOR_DRAWER_SKILLS_TYPES];

export interface ProfileEditorDrawerSkillsContextInfo {
  currentType: ProfileEditorDrawerSkillsType;
  setCurrentType: React.Dispatch<React.SetStateAction<ProfileEditorDrawerSkillsType>>;
  optionsPicked: any[];
  setOptionsPicked: React.Dispatch<React.SetStateAction<any[]>>;
  skillsCreated: any[];
  setSkillsCreated: React.Dispatch<React.SetStateAction<any[]>>;
  options: any[];
  handleOptionsChanged: (options: any[], selectedOption?: any) => void;
  highlightedSkillIdentifier: string | null;
  setHighlightedSkillIdentifier: React.Dispatch<React.SetStateAction<string | null>>;
}

export const ProfileEditorDrawerSkillsContext = createContext<ProfileEditorDrawerSkillsContextInfo>(
  {
    currentType: PROFILE_EDITOR_DRAWER_SKILLS_TYPES.SKILL,
    setCurrentType: () => {},
    optionsPicked: [],
    setOptionsPicked: () => {},
    skillsCreated: [],
    setSkillsCreated: () => {},
    options: [],
    handleOptionsChanged: () => {},
    highlightedSkillIdentifier: null,
    setHighlightedSkillIdentifier: () => {},
  }
);
